import { Component, OnInit, Directive } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { ProjectsService, ProposalsService } from '../services/projects-proposals-service/projects-proposals.service';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive()
export class HourControlComponent implements OnInit {
  public projectList = [];
  private unsubscriber : Subject<void> = new Subject<void>();

  constructor(public translate: TranslateService, public languageService: LanguageService, private baseService: ProjectsService | ProposalsService, public tipus, private router: Router) {
    this.ngOnInit();
   }

  private reducer(state, {action, newState}): any {
     switch (action) {
       case 'ADD':
         return state.map(project => {
            if (project.id === newState.projectId) {
              return Object.assign({}, project, {
                taskList: [newState, ...project.taskList]
              });
            }
            return project;
          });
       case 'REMOVE':
       return state.map(project => {
          if (project.id === newState.projectId) {
            const updatedTaksList = project.taskList.filter(task => task.id !== newState.id);
            return Object.assign({}, project, {taskList: updatedTaksList});
          }
          return project;
        });
       case 'UPDATE':
       return state.map(project => {
          if (project.id === newState.projectId) {
            const updatedTaksList = project.taskList.map(task => {
              if (task.id === newState.id) {
                return Object.assign({}, newState);
              }
              return task;
            });
            return Object.assign({}, project, {taskList: updatedTaksList});
          }
          return project;
        });
       default:
        return state;
     }
  }

  public dispatch($event) {
    const {action, newState} = $event;
    const { id } = newState;

    switch (action) {
      case 'ADD':
        if (newState.hours === 0) {
          return;
        }
        this.baseService.createTask(newState)
        .subscribe(
          asyncState => {
            this.projectList = this.reducer(this.projectList, {
              action: action,
              newState: asyncState
            });
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate([(this.tipus == 'treball'?'projects':'proposals')+'/hours']);
          },
          err => console.log(err)
        );
        break;
      case 'UPDATE':
       this.baseService.updateTask(id, newState)
         .subscribe(
           asyncState => {
             this.projectList = this.reducer(this.projectList, {
               action: action,
               newState: asyncState
             });
             this.router.routeReuseStrategy.shouldReuseRoute = () => false;
             this.router.onSameUrlNavigation = 'reload';
             this.router.navigate([(this.tipus == 'treball'?'projects':'proposals')+'/hours']);
           },
           err => console.log(err)
         );
         break;
      case 'REMOVE':
        this.baseService.destroyTask(id)
          .subscribe(
            asyncState => {
              this.projectList = this.reducer(this.projectList, {
                action: action,
                newState: asyncState
              });
             this.router.routeReuseStrategy.shouldReuseRoute = () => false;
             this.router.onSameUrlNavigation = 'reload';
             this.router.navigate([(this.tipus == 'treball'?'projects':'proposals')+'/hours']);
            },
            err => console.log(err)
          );
    }
  }

  ngOnInit() {
    this.baseService.getOwnProjectsTask()
      .subscribe(
        projectList => this.projectList = projectList.map(item => {
          return (item);
        }),
        err => console.log(err)
      );

    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  navigate(){
   this.router.navigate([(this.tipus == 'treball'?'propostes':'projects'),'hours']);
  }

}

@Component({
  templateUrl: './hour-control.component.html',
  styleUrls: ['./hour-control.component.css'],
  selector: 'mcrit-gestio-hour-control-project',
  providers: [ProjectsService, ProposalsService]
}
)
export class ProjectHourControlComponent extends HourControlComponent {
  constructor(public translate: TranslateService, public languageService: LanguageService, projectsService: ProjectsService, router: Router) {
    super(translate, languageService, projectsService,'treball', router);
  }
  navigate(){super.navigate()}
};

@Component({
  templateUrl: './hour-control.component.html',
  styleUrls: ['./hour-control.component.css'],
  selector: 'mcrit-gestio-hour-control-proposal',
  providers: [ProjectsService, ProposalsService]
}
)
export class ProposalHourControlComponent extends HourControlComponent {
  constructor(public translate: TranslateService, public languageService: LanguageService, proposalsService: ProposalsService, router: Router) {
    super(translate, languageService, proposalsService,'proposta', router);
  }
  navigate(){super.navigate()}
};
